<div data-e2e="basket-id-container" class="custom-radio">
  <input
    data-e2e="basket-selector-radio"
    class="custom-control-input"
    type="radio"
    [id]="basket.id"
    [checked]="isActive"
    (click)="onBasketClicked(basket.id, $event)"
  />
  <label
    class="custom-control-label d-flex pt-2 pl-3 pr-2 pb-3"
    [for]="basket.id"
    [ngClass]="{ active: isActive }"
  >
    <dl class="ml-4 my-0">
      <dt
        data-e2e="basket-id"
        class="mb-2"
        i18n="basketManager|Basket Id @@basketId"
      >
        Basket ID: {{ basket.orderReferenceNumber }}
      </dt>

      <!-- Basket name -->
      <ng-container
        *epcFeatureFlag="
          basketNameFeatureKey;
          namespace: cbasketNamespace;
          equality: true;
          defaultValue: false
        "
      >
        @if (basket.clientReferenceNumber) {
        <dd class="mb-1 badge badge-light badge-basket-name border">
          {{ basket.clientReferenceNumber }}
        </dd>
        }
      </ng-container>

      <dd class="mb-1 text-muted" i18n="basketManager|Store label@@storeLabel">
        Store: {{ getStoreAddresses() }}
      </dd>
      <dd
        class="mb-1 text-muted"
        i18n="basketManager|Creation Time@@creationTime"
      >
        Created on {{ basket.createdTime | date }}
      </dd>
      <dd class="mb-0 text-muted">
        <ul class="mb-0">
          <li i18n="basketManager|Total Quantity@@totalQuantity">
            {{ basket.totalQuantity }} items
          </li>
          <li>
            {{ getCurrency() | uppercase }}
            {{ getTotalValue() | number: '1.2-2' }}
          </li>
        </ul>
      </dd>
    </dl>
    <div
      class="ml-auto d-flex flex-column align-items-end justify-content-between"
    >
      <epc-basket-status-badge
        [value]="basketStatus | uppercase"
      ></epc-basket-status-badge>
      @if (canBeDeleted$ | async) {
      <button
        type="button"
        class="btn-delete-basket btn btn-round btn-outline-light"
        (click)="onDeleteBasket(basket.id)"
      >
        <fa-icon size="sm" [icon]="['fas', 'trash']"> </fa-icon>
      </button>
      }
    </div>
  </label>
</div>
